import { useCallback, useEffect } from 'react';
import { GlobalActions } from '../../../model';
import { prepareRegistration } from '../../../store';
import { useAppDispatch, useAppSelector } from '../../redux';
import { commonErrorMessages } from '../../../messages';
import { appRoutes } from '../../../routing';
import { useIntl } from 'react-intl';

export interface WelcomeUserRegistrationPageLogicCallbacks {
  goAhead: () => void;
}

export const useWelcomeUserRegistrationPageLogic = (
  actions: GlobalActions
): WelcomeUserRegistrationPageLogicCallbacks => {
  const dispatch = useAppDispatch();
  const { showToast, closeToast, navigate } = actions;
  const { formatMessage } = useIntl();
  const { prepareRegistrationRequestStatus, prepareRegistrationError } =
    useAppSelector((state) => state.features.userRegistration);

  const goAhead = useCallback(() => {
    dispatch(prepareRegistration());
  }, [dispatch]);

  useEffect(() => {
    if (prepareRegistrationRequestStatus === 'succeeded') {
      navigate(appRoutes.InformativeUserRegistration, { replace: false });
    } else if (prepareRegistrationRequestStatus === 'failed') {
      showToast({
        type: 'error',
        title: formatMessage(commonErrorMessages.errorTitleDefault),
        description: formatMessage(commonErrorMessages.errorDescriptionDefault),
        close: closeToast,
      });
    }
  }, [
    prepareRegistrationRequestStatus,
    prepareRegistrationError,
    navigate,
    showToast,
    formatMessage,
    closeToast,
  ]);

  return {
    goAhead: goAhead,
  };
};
